import { WebPlugin } from '@capacitor/core';
import { OrientationType } from './definitions';
export class ScreenOrientationWeb extends WebPlugin {
    constructor() {
        super();
        this.handleOrientationChange = async () => {
            const result = await this.getCurrentOrientation();
            const changeEvent = {
                type: result.type,
            };
            this.notifyListeners('screenOrientationChange', changeEvent);
        };
        try {
            this.isSupported = 'orientation' in screen;
        }
        catch (_a) {
            this.isSupported = false;
        }
        if (this.isSupported) {
            screen.orientation.addEventListener('change', this.handleOrientationChange);
        }
    }
    async lock(options) {
        var _a;
        if (!this.isSupported) {
            this.throwUnsupportedError();
        }
        const type = (_a = options === null || options === void 0 ? void 0 : options.type) !== null && _a !== void 0 ? _a : screen.orientation.type;
        await screen.orientation.lock(type);
    }
    async unlock() {
        if (!this.isSupported) {
            this.throwUnsupportedError();
        }
        screen.orientation.unlock();
    }
    async getCurrentOrientation() {
        if (!this.isSupported) {
            this.throwUnsupportedError();
        }
        switch (screen.orientation.type) {
            case 'landscape-primary':
                return { type: OrientationType.LANDSCAPE_PRIMARY };
            case 'landscape-secondary':
                return { type: OrientationType.LANDSCAPE_SECONDARY };
            case 'portrait-secondary':
                return { type: OrientationType.PORTRAIT_SECONDARY };
            default:
                return { type: OrientationType.PORTRAIT_PRIMARY };
        }
    }
    throwUnsupportedError() {
        throw this.unavailable('Screen Orientation API not available in this browser.');
    }
}
//# sourceMappingURL=web.js.map